// extracted by mini-css-extract-plugin
export default {"modalOverlay":"rH-z","modalContent":"sH-z","header":"tH-z","close":"uH-z"};